<script>
    export let activeTab;
</script>

<div class="header {activeTab === 'schedule' ? 'hi-header' : ''}">
    <div><div class="flex-center">
        <img style="border-radius: 50%; box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;" class="icon" src="./favicon.png" alt="logo">
    </div>
    <span class="font-size text-align-center whisper-regular flex-center">Adriana Brows</span>
    <div class="flex-center">
        <img class="small-icon" src="./icons/instagram.png" alt="instagram">
        <a href="https://www.instagram.com/adrianabrows_?igsh=MTVobWRvZDF4aW02Yg%3D%3D" style="margin-left:10px; color:black;">adrianabrows_</a>
    </div>
    </div>
</div>

<style>
    .hi-header{
        width:auto;
        display:flex;
        padding: 20px 0 0 7px !important;
        justify-content: center;
    }
    .header{
        width:auto;
        padding: 20px;
        border-radius: 5px;
    }
    .font-size{
        font-size: 3rem;
    }
    .icon{
        width: 100px;
        height: 100px;
    }
    .flex-center{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .text-align-center{
        text-align: center;
    }
    .whisper-regular {
        font-family: "Whisper", cursive !important;
        font-weight: 400;
        font-style: normal;
    }
    .small-icon{
        width: 20px;
        height: 20px;
    }
    @media (max-width: 768px) {
        .hi-header {
            justify-content: unset;
        }
    }
</style>
